import React from "react";
import PropTypes from "prop-types";

import Helmet from "../../components/Helmet";
import Loading from "../../components/Loading";
import EventBanner from "../../components/event/EventBanner";
import { useEventParticipationSubmission } from "../../context/EventParticipationSubmissionManager";
import { Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";

function EventParticipationSubmissionPage({ event }) {
    const { existingSubmissions } = useEventParticipationSubmission();

    if (!event) {
        return (
            <div className="background-black">
                <div className="d-flex flex-column justify-content-center w-100">
                    <Loading />
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <Helmet
                title={`Inschrijven voor ${event.name}`}
            />
            <div className="background-black">
                <div className="d-flex flex-column justify-content-center w-100">
                    <EventBanner
                        event={event}
                        backLink={`/event/${event.id}`}
                        backLinkText="Terug naar evenement"
                    />
                    <div className="container">
                        {existingSubmissions && (
                            <div className="alert alert-warning">
                                    Let op! Je hebt al ingeschreven voor dit evenement.
                            </div>
                        )}
                        <h1 className="text-white">{event.name}</h1>
                        {event.eventParticipationSubmissionIntroText ? (
                            <ReactMarkdown className="text-white">{event.eventParticipationSubmissionIntroText}</ReactMarkdown>
                        ) : (
                            <p className="text-white">Start de inschrijving voor {event.name}</p>
                        )}
                        <Link
                            to={`/event/${event.id}/participation-submission/naw`}
                            className="btn btn-primary"
                        >
                                Start inschrijving
                        </Link>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

EventParticipationSubmissionPage.propTypes = {
    event: PropTypes.shape({
        name: PropTypes.string.isRequired,
        eventParticipationSubmissionIntroText: PropTypes.string,
        id: PropTypes.string.isRequired,
    }).isRequired,
};

export default EventParticipationSubmissionPage;
